















import axios from "axios";
import { HotTable } from "@handsontable/vue";
import Handsontable from "handsontable";
import { Vue, Component, Watch, Prop } from "vue-property-decorator";

@Component({
  components: {
    HotTable,
  },
})
export default class TabularDataGrid extends Vue {
  private dataset = [];
  private colHeaders = [
    "ID",
    "DSID",
    "ISO3",
    "Dst name",
    "Dst Lat",
    "Dst Lon",
    "Stock Total",
    "Start Date",
    "End Date",
  ];
  private columns = [
    { data: "id", readOnly: true },
    { data: "parent_id", readOnly: true },
    { data: "iso3", readOnly: true },
    { data: "dst_name" },
    { data: "dst_lat" },
    { data: "dst_lon" },
    {
      data: "stock_total",
      type: "numeric",
      numericFormat: { pattern: "0,0.00" },
    },
    {
      data: "start_date",
      type: "date",
      dateFormat: "MM/DD/YYYY",
      correctFormat: true,
    },
    {
      data: "end_date",
      type: "date",
      dateFormat: "MM/DD/YYYY",
      correctFormat: true,
    },
  ];

  private nestedHeaders = [
    ["", { label: "B", colspan: 8 }, "C"],
    ["ID", { label: "B", colspan: 8 }, "C"],
  ];

  async created() {
    console.log("created!");
    let response = await axios.get("/psql/tabular_datasets_records", {
      params: {
        parent_id: `eq.17`,
        select: `id,parent_id,iso3,dst_name,dst_lat,dst_lon,stock_total,start_date,end_date`,
        limit: 5000,
      },
    });
    this.dataset = response.data;
    // console.log(this.dataset);
  }
}
